module.exports = function () {
	var afterVideoOpens = function (e) {
		var videoFrame = $('.modaal-video-frame');
		var srcAutoPlay = videoFrame.attr('src');

		videoFrame.removeAttr('allowfullscreen');
		videoFrame.attr('allow', 'autoplay; fullscreen');
		videoFrame.attr('src', srcAutoPlay);
	};

	$('.embedded-video__title[href], .embedded-video__video-toggle-img[href]').modaal({
		type: 'video',
		after_callback_delay: 0,
		after_open: afterVideoOpens
	});
};
